import { render, staticRenderFns } from "./SupplierProductDetail.vue?vue&type=template&id=2245dd1b"
import script from "./SupplierProductDetail.vue?vue&type=script&lang=js"
export * from "./SupplierProductDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports